import { render, staticRenderFns } from "./JvectorMap.vue?vue&type=template&id=32c373ab&"
import script from "./JvectorMap.vue?vue&type=script&lang=js&"
export * from "./JvectorMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports